<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UdJyyd/tc-custom/9781912866922.jpg?1708774724134" alt="This image is the cover for the book Bandit Mentality"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bandit Mentality
      </h1>
      <p class="bookDescription body article font2">
        <b>A former officer of British South Africa’s anti-terrorist unit recounts his experiences on the frontlines of the Rhodesian Bush war </b><b>from 1976–1980.</b><br/>  <br/> A native of New Zealand, Lindsay ‘Kiwi’ O’Brien served in the British South Africa Police Support Unit’s anti-terrorist battalion. He traveled across the country as a section leader and a troop commander before joining the UANC political armies as trainer and advisor.<br/>  <br/> The BSA Support Unit started poorly supplied and equipped, but the caliber of the men, mostly African, was second-to-none. Support Unit specialized in the “grunt” work inside Rhodesia with none of the flamboyant helicopter or cross-border raids carried out by the army. O’Brien’s war was primarily within selected tribal lands, seeking out and destroying Communist guerilla units in brisk close-range battles with little to no support.<br/>  <br/> O’Brien moved from the police to working with the initial UANC deployment in the Zambezi Valley where the poorly trained recruits had to learn fast or die. O’Brien’s account is a foreign-born perspective from a junior commander uninterested in promotion and the wrangling of upper command. He was decorated and wounded three times.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lindsay O’Brien
      </h2>
      
      <p class="authorDescription body article">The author was born and raised in New Zealand, joining the NZ Army at 16 in order to run away from home. Afterwards, he roamed around Queensland Australia on construction sites before heading off to London via Johannesburg. In South Africa he stopped over and hitchhiked around before heading up to Rhodesia, and subsequently found work managing a tobacco farm. The farm lay inside the war zone and two years later, after several incidents, he joined the BSA Police where he was involved in the fighting between the government forces and nationalist insurgents until the ceasefire in December 1979. He was awarded the highest police gallantry award. Subsequently, he has mined in Tasmania, rose to senior management in a retail chain in Queensland and Victoria and has been running his own businesses for the past 20 years in Queensland. Currently he is writing and running a small business in Queensland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Helion and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?50dc933e